import React, { useEffect, useState } from "react";

import { CloseOutlined } from "@ant-design/icons";
import { Button } from "antd";

import SubmitButton from "./SubmitButton";
import "./TemplateSave.css";

const TAG_OPTIONS = [
  // { tag: "red", color: "#E63559" },
  // { tag: "blue", color: "#3874FF" },
  // { tag: "yellow", color: "#E1B226" },
  // { tag: "orange", color: "#F98006" },
  // { tag: "green", color: "#1EC04A" },
  { tag: "teal", color: "#0C6B83" },
  { tag: "analyticsblue", color: "#1863DC" },
  { tag: "purple", color: "#8A1CFF" },
  { tag: "sage", color: "#5D7D23" },
];

const AVAILABLE_TAGS = new Set(TAG_OPTIONS.map(({ tag }) => tag));

const isAvailableTag = (tag) => AVAILABLE_TAGS.has(tag);

export default function TemplateSave({
  handleSaveTemplate,
  selectedTemplate,
  toggleSaveModal,
  setSaveStatus,
  saveStatus,
  inline = false,
}) {
  const [input, setInput] = useState(selectedTemplate ? selectedTemplate.name : "");
  const [activeTag, setActiveTag] = useState(selectedTemplate ? selectedTemplate.tags[0] : null);
  const [disableSubmit, setDisableSubmit] = useState(true);

  const onChange = (value) => {
    if (!value.includes("/")) {
      setInput(value);
    }
  };

  const handleTag = (tag) => {
    setActiveTag(tag);
  };

  const checkInputs = () => isAvailableTag(activeTag) && input.trim();

  const handleCheckAndSaveTemplate = () => {
    const validInputs = checkInputs();
    if (validInputs) {
      setSaveStatus("loading");
      handleSaveTemplate({ name: input, tags: [activeTag] });
    }
  };

  useEffect(() => {
    setDisableSubmit(!checkInputs());
  }, [activeTag, input]); // eslint-disable-line

  const formContent = (
    <>
      <div className={inline ? "BuilderTemplateDetails__Body" : "templateSavePopupBody"}>
        <label className="saveInputSectionTop">
          <span className="saveInputSectionInputTitle">Template Name</span>
          <input
            className="templateBuilderInput"
            type="text"
            placeholder="Enter Name"
            value={input}
            onChange={((e) => onChange(e.target.value))}
            autoComplete="off"
          />
        </label>

        <label className={inline ? "BuilderTemplateDetails__Tags" : "saveInputSectionBottom"}>
          <span className="saveInputSectionInputTags">Tags</span>
          <div className={inline ? "BuilderTemplateDetails__TagRow" : "saveInputSectionTags"}>
            {TAG_OPTIONS.map(({ tag, color }) => (
              <div
                key={tag}
                onClick={() => handleTag(tag)}
                className={tag === activeTag ? "saveInputSectionColorTag saveInputSectionColorTagActive" : "saveInputSectionColorTag"}
                style={{ backgroundColor: color }}
              />
            ))}
          </div>
        </label>
      </div>
      <div className={inline ? "BuilderTemplateDetails__Footer" : "templateSavePopupFooter"}>
        {saveStatus !== "success" && (
          <SubmitButton
            loading={saveStatus === "loading"}
            disabled={disableSubmit}
            handleSaveTemplate={handleCheckAndSaveTemplate}
            text="Save Template"
          />
        )}
      </div>
    </>
  );

  if (inline) {
    return (
      <div className="BuilderTemplateDetails">
        {formContent}
      </div>
    );
  }

  return (
    <div className="templateSavePopup">
      {
        saveStatus === null && (
        <Button
          htmlType="button"
          className="TemplateSave__DeleteButton"
          aria-label="Close"
          onClick={() => toggleSaveModal(true)}
        >
          <CloseOutlined />
        </Button>
        )
      }
      {formContent}
    </div>
  );
}
